import React, { useState, useEffect } from 'react';
import { Star, ExternalLink, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const GoogleReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Reviews reais do Google - Apenas comentário e data
  const reviews = [
    {
      id: 1,
      rating: 5,
      text: 'Melhor empresa! Melhor atendimento! Melhores viagens!! A Tô Indo Ali superou todas as minhas expectativas. Equipe dedicada e profissional. Recomendo de olhos fechados!',
      date: 'Outubro 2024',
      source: 'Google Reviews'
    },
    {
      id: 2,
      rating: 5,
      text: 'Viajar sozinha sempre foi uma experiência que gostaria de viver, mas que nunca tive coragem. Conhecer a Tô Indo Ali mudou minha vida!!! Segurança e acolhimento em cada momento da viagem.',
      date: 'Setembro 2024',
      source: 'Google Reviews'
    },
    {
      id: 3,
      rating: 5,
      text: 'Ninguém solta a mão de ninguém! Os guias Ícaro e Flávio são incríveis. Experiência transformadora na Chapada Diamantina com muita segurança e organização. Super recomendo!',
      date: 'Novembro 2024',
      source: 'Google Reviews'
    },
    {
      id: 4,
      rating: 5,
      text: 'Já fiz 3 viagens com a Tô Indo Ali e todas foram perfeitas! Roteiros bem planejados, guias experientes e muita diversão. Já estou planejando a próxima aventura!',
      date: 'Dezembro 2024',
      source: 'Google Reviews'
    },
    {
      id: 5,
      rating: 5,
      text: 'Melhor experiência de viagem que já tive! A equipe é super atenciosa, tudo muito bem organizado. Fui para Jalapão e voltei encantado. Já quero a próxima!',
      date: 'Novembro 2024',
      source: 'Google Reviews'
    }
  ];

  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % reviews.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, reviews.length]);

  const nextReview = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const googleReviewsUrl = 'https://www.google.com/search?q=toindoali+turismo#lrd=0xbc61b893ac7a6f:0xa66388dd748876fa,1';

  return (
    <section className="py-8 sm:py-12 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header com nota do Google */}
        <div className="text-center mb-6 sm:mb-8">
          <div className="flex items-center justify-center gap-2 mb-2">
            {/* Google Logo */}
            <svg className="w-6 h-6" viewBox="0 0 48 48">
              <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
              <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
              <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
              <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
            </svg>
            <div className="flex items-center gap-2">
              <span className="text-2xl sm:text-3xl font-bold text-gray-900">5.0</span>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" />
                ))}
              </div>
            </div>
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">
            Avaliações dos nossos viajantes
          </h2>
          <p className="text-sm text-gray-600">
            42 avaliações verificadas no Google
          </p>
        </div>

        {/* Reviews Carousel */}
        <div className="relative max-w-3xl mx-auto">
          <Card className="shadow-lg border-0 overflow-hidden">
            <CardContent className="p-0">
              <div className="bg-white p-4 sm:p-6">
                {/* Quote Icon */}
                <Quote className="w-6 h-6 sm:w-8 sm:h-8 text-[#FFD700] mb-2 opacity-50" />
                
                {/* Review Text */}
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 min-h-[60px] sm:min-h-[80px]">
                  "{reviews[currentIndex].text}"
                </p>
                
                {/* Review Info - Apenas estrelas e data */}
                <div className="flex items-center justify-between border-t border-gray-100 pt-3">
                  <div className="flex items-center gap-2">
                    <div className="flex">
                      {[...Array(reviews[currentIndex].rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" />
                      ))}
                    </div>
                    <span className="text-gray-500">•</span>
                    <span className="text-xs sm:text-sm text-gray-600">{reviews[currentIndex].date}</span>
                  </div>
                  
                  {/* Google Badge */}
                  <a
                    href={googleReviewsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 text-xs text-gray-500 hover:text-[#003366] transition-colors"
                  >
                    <svg className="w-4 h-4" viewBox="0 0 48 48">
                      <path fill="#4285F4" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                    </svg>
                    <span className="hidden sm:inline">Google</span>
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Navigation Buttons */}
          <button
            onClick={prevReview}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 sm:-translate-x-4 md:-translate-x-10 bg-white hover:bg-gray-50 text-gray-800 p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10"
            aria-label="Avaliação anterior"
          >
            <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
          <button
            onClick={nextReview}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 sm:translate-x-4 md:translate-x-10 bg-white hover:bg-gray-50 text-gray-800 p-1.5 sm:p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10"
            aria-label="Próxima avaliação"
          >
            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center space-x-1.5 mt-4">
            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setIsAutoPlaying(false);
                  setCurrentIndex(index);
                }}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-[#FFD700] w-6'
                    : 'bg-gray-300 hover:bg-gray-400 w-1.5'
                }`}
                aria-label={`Ir para avaliação ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-6">
          <a
            href={googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white border-2 border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-white px-5 py-2 rounded-full font-semibold text-sm transition-all duration-300"
          >
            Ver todas no Google
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
